<template>
  <div class="main">
    <div :class="['home-herder', { 'home-herder-en': $i18n.locale === 'en' }]">
      <img
        class="logo"
        src="@/assets/image/common/logo-bule.png"
        @click="goUrl('/')"
      />
      <div class="text-box">
        <div
          @click="goUrl('/module/home')"
          :class="[{ active: active === '/module/home' }]"
        >
          {{ $t("module.herder.title1") }}
          <span class="line" v-if="active === '/module/home'"></span>
        </div>
        <div
          @click="goUrl('/module/task')"
          :class="[{ active: active === '/module/task' }]"
        >
          {{ $t("module.herder.title2") }}
          <span class="line" v-if="active === '/module/task'"></span>
        </div>
        <div
          @click="goUrl('/module/exchange')"
          :class="[{ active: active === '/module/exchange' }]"
        >
          {{ $t("module.herder.title3") }}
          <span class="line" v-if="active === '/module/exchange'"></span>
        </div>
        <div
          @click="goUrl('/module/activity')"
          :class="[{ active: active === '/module/activity' }]"
        >
          {{ $t("module.herder.title4") }}
          <span class="line" v-if="active === '/module/activity'"></span>
        </div>
        <div
          @click="goUrl('/module/help')"
          :class="[{ active: active === '/module/help' }]"
        >
          {{ $t("module.herder.title5") }}
          <span class="line" v-if="active === '/module/help'"></span>
        </div>
        <div class="lang-box" @click="changeLang" v-if="false">
          <img class="lang" src="@/assets/image/common/lang-black.png" />
          <span>{{ $t("lang") }}</span>
        </div>
        <div class="user-box" v-if="token">
          <el-badge :value="counts ? counts : null" class="item">
            <img
              class="bell"
              @click="bellShow = !bellShow"
              src="@/assets/image/module/bell.png"
            />
            <div class="bell-flex" v-if="bellShow">
              <span class="bell-title">{{ $t("module.notice.title1") }}</span>
              <div class="bell-operation">
                <span class="bell-left" @click="clearMessage">{{
                  $t("module.notice.title2")
                }}</span>
                <span class="bell-right" @click="getMessageRead">全部已读</span>
              </div>

              <div
                class="bell-content"
                ref="scrollContainer1"
                @scroll="handleScroll1"
              >
                <div
                  class="bell-item"
                  v-for="(item, index) in tableData"
                  :key="index"
                >
                  <div class="bell-item-left">
                    <div class="bell2">
                      <img src="@/assets/image/module/bell2.png" />
                      <span v-if="!item.IsRead"></span>
                    </div>
                    <div
                      class="bell-text-box"
                      @click="goUrl(`/module/notice?title=${item.Title}`)"
                    >
                      <span class="bell-text">{{ item.Title }}</span>
                      <span class="bell-time">{{
                        item.SendTime | dateFrom
                      }}</span>
                    </div>
                  </div>
                  <el-dropdown
                    trigger="click"
                    @command="(cmd) => messageCommand(cmd, item, index)"
                  >
                    <span class="el-dropdown-link">
                      <img
                        class="treee"
                        src="@/assets/image/module/treee.png"
                      />
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="delete">{{
                        $t("module.notice.title4")
                      }}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>

                <div class="empty-box" v-if="tableData.length === 0">
                  <el-empty description="暂无数据"></el-empty>
                </div>
              </div>
            </div>
          </el-badge>

          <img
            class="head"
            v-if="$store.state.userInfo.avatarUrl"
            :src="`${$Url}${$store.state.userInfo.avatarUrl}`"
          />
          <img class="head" v-else src="@/assets/image/module/head.png" />
          <div class="name">{{ $store.state.userInfo.userName }}</div>
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              <img class="arrow" src="@/assets/image/module/arrow-down.png" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="a">{{
                $t("home.homeHerder.title9")
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <div class="btn" v-else>
          <span @click="goUrl('/login')">{{
            $t("home.homeHerder.title7")
          }}</span>
          <span class="vertical"></span>
          <span @click="goUrl('/register')">{{
            $t("home.homeHerder.title8")
          }}</span>
        </div>
      </div>

      <div class="storage-box">
        <el-badge :value="counts ? counts : null" v-if="token" class="item">
          <img
            class="bell"
            @click="bellShow = !bellShow"
            src="@/assets/image/module/bell.png"
          />
          <div class="bell-flex" v-if="bellShow">
            <span class="bell-title">{{ $t("module.notice.title1") }}</span>
            <div class="bell-operation">
              <span class="bell-left" @click="clearMessage">{{
                $t("module.notice.title2")
              }}</span>
              <span class="bell-right" @click="getMessageRead">全部已读</span>
            </div>

            <div class="bell-content">
              <div
                class="bell-item"
                v-for="(item, index) in tableData"
                :key="index"
              >
                <div class="bell-item-left">
                  <div class="bell2">
                    <img src="@/assets/image/module/bell2.png" />
                    <span v-if="!item.IsRead"></span>
                  </div>
                  <div
                    class="bell-text-box"
                    @click="goUrl(`/module/notice?title=${item.Title}`)"
                  >
                    <span class="bell-text">{{ item.Title }}</span>
                    <span class="bell-time">{{
                      item.SendTime | dateFrom
                    }}</span>
                  </div>
                </div>
                <el-dropdown
                  trigger="click"
                  @command="(cmd) => messageCommand(cmd, item, index)"
                >
                  <span class="el-dropdown-link">
                    <img class="treee" src="@/assets/image/module/treee.png" />
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="delete">{{
                      $t("module.notice.title4")
                    }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>
        </el-badge>
        <img
          class="storage"
          @click="show = !show"
          src="@/assets/image/common/storage.png"
        />
      </div>
      <HerderList v-if="show" @close="show = false"></HerderList>
    </div>

    <div class="content">
      <router-view />
    </div>

    <!-- 页脚 -->
    <div
      class="footer-box"
      :style="`background-color:${
        this.active === '/module/exchange' ? '#FAFAFA' : '#fff'
      }`"
    >
      <div class="content-box">
        <div class="icon-box" @click="goUrl('/')">
          <img src="@/assets/image/common/logo-bule.png" />
        </div>
        <div class="line"></div>
        <div class="info-boxs">
          <div class="info-box">
            <div class="herder">{{ $t("home.footer.title3") }}</div>
            <div class="tips">
              我是内容我是内容我是内容 我是内容我是内容我是内容 我是内容我是内容
            </div>
          </div>
          <div class="info-box">
            <div class="herder">{{ $t("home.footer.title4") }}</div>

            <div class="item-box">
              <div class="item">{{ $t("home.footer.title5") }}</div>
              <div class="item">{{ $t("home.footer.title6") }}</div>
            </div>
          </div>
          <div class="info-box">
            <div class="herder">{{ $t("home.footer.title7") }}</div>
            <div class="item-box">
              <div class="item">{{ $t("home.footer.title8") }}</div>
              <div class="item">{{ $t("home.footer.title9") }}</div>
            </div>
          </div>
          <div class="info-box">
            <div class="herder">{{ $t("home.footer.title10") }}</div>
            <div class="item-box">
              <div class="item">{{ $t("home.footer.title11") }}</div>
              <div class="item">{{ $t("home.footer.title12") }}</div>
              <div class="item">{{ $t("home.footer.title13") }}</div>
            </div>
          </div>
          <div class="info-box">
            <div class="herder">
              <img src="@/assets/image/module/emali-black.png" />
              <span>1234567890@163.com</span>
            </div>
            <div class="code-box">
              <img src="@/assets/image/home/weixin.png" />
              <div>{{ $t("home.footer.title14") }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="filing">
        Copyright © 2023 All Rights Reserved.版权所有
        江北新区研科计算机系统服务中心 苏ICP备123456789号-1
      </div>
    </div>
    <!-- 页脚移动端 -->
    <div class="footer-box2">
      <div class="content-box">
        <div class="icon-box" @click="goUrl('/')">
          <img src="@/assets/image/common/logo-bule.png" />
        </div>
        <div class="line"></div>
        <div class="info-boxs">
          <div class="info-box">
            <div class="item-box">
              <div class="item">{{ $t("home.footer.title5") }}</div>
              <div class="item">{{ $t("home.footer.title8") }}</div>
              <div class="item">{{ $t("home.footer.title9") }}</div>
            </div>
          </div>
          <div class="info-box">
            <div class="item-box">
              <div class="item">{{ $t("home.footer.title13") }}</div>
              <div class="item">{{ $t("home.footer.title11") }}</div>
              <div class="item">{{ $t("home.footer.title12") }}</div>
            </div>
          </div>
          <div class="info-box">
            <div class="item-box">
              <div class="item">{{ $t("home.footer.title15") }}</div>
              <div class="herder">
                <img src="@/assets/image/module/emali-black.png" />
                <span>1234567890@163.com</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="filing">
        <div>Copyright © 2023 All Rights Reserved.</div>
        <div>版权所有 江北新区研科计算机系统服务中心</div>
        <div>苏ICP备123456789号-1</div>
      </div>
    </div>
  </div>
</template>
<script>
import HerderList from "@/components/Mobile/herderList.vue";
import {
  getAccount,
  getMessageCounts,
  getMessages,
  deleteMessages,
  getMessageRead,
  clearMessage,
} from "@/api/user";
export default {
  filters: {
    dateFrom(timeString) {
      if (!timeString || typeof timeString !== 'string') {
        return '';
      }
      
      const date = new Date(timeString);
      
      // 检查日期是否有效
      if (isNaN(date.getTime())) {
        return '';
      }
      
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
  },
  data() {
    return {
      scrollTop: 0,
      screenWidth: 0,
      active: "",
      show: false,
      bellShow: false,
      userInfo: {},
      token: null,
      counts: 0,
      tableData: [],
      page: 1,
      size: 10,
      flag: false,
    };
  },

  watch: {
    $route(to, from) {
      this.getActive(to.path);
    },
  },

  components: { HerderList },
  methods: {
    //监听页面滚动
    scrollToTop() {
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
    },
    handleResize() {
      this.screenWidth = window.innerWidth;
      console.log("1111", this.screenWidth);
    },
    //改变语言
    changeLang() {
      return
      if (this.$i18n.locale === "zn") {
        // 判断当前语言
        this.$i18n.locale = "en"; // 设置当前语言
          localStorage.setItem("lang", "en");
      } else {
        this.$i18n.locale = "zn";
          localStorage.setItem("lang", "zn");
      }
    },
    //跳转
    goUrl(path) {
      console.log("触发");
      switch (path) {
        case "/module/home":
          if (localStorage.getItem("login")) {
            this.$router.push(path);
          } else {
            this.$router.push("/home");
          }
          break;
        default:
          this.$router.push(path);
      }
    },
    handleCommand(command) {
      switch (command) {
        case "a":
          localStorage.clear();
          this.$router.push("/login");
          this.userInfo = {};
          this.$store.commit("changeUserInfo", this.userInfo);
          break;
      }
    },
    //获取状态
    getActive(path) {
      switch (path) {
        case "/module/home":
        case "/module/taskRecord":
        case "/module/redemptionHistory":
        case "/module/goldHistory":
        case "/module/account":
        case "/module/invite":
        case "/module/creditValue":
          this.active = "/module/home";
          break;
        case "/module/task":
        case "/module/taskDetails":
          this.active = "/module/task";
          break;
        case "/module/exchange":
          this.active = "/module/exchange";
          break;
        case "/module/activity":
          this.active = "/module/activity";
          break;
        case "/module/help":
          this.active = "/module/help";
          break;
      }
    },

    //
    getMessageCounts() {
      getMessageCounts().then((res) => {
        if (res.code === 200) {
          this.counts = res.data;
        }
      });
    },

    getMessages(type) {
      if (type) {
        this.page = type;
        this.flag = false;
        this.tableData = [];
      }

      if (this.flag) {
        return;
      }
      getMessages({
        page: this.page,
        size: this.size,
        read:false,
      }).then((res) => {
        if (res.code === 200) {
          if (res.data.list.length > 0) {
            this.tableData = this.tableData.concat(res.data.list);
            if (res.data.list.length === 10) {
              this.page++;
            } else {
              this.flag = true;
            }
          }
        }
      });
    },

    handleScroll1(e) {
      const container = this.$refs.scrollContainer1;
      // console.log(
      //   container.scrollTop + container.clientHeight,
      //   container.scrollHeight
      // );
      // 检查是否接近底部
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 1
      ) {
        // 触底逻辑，例如加载更多数据
        console.log("触底");
        this.getMessages();
      }
    },
    messageCommand(e, data, index) {
      console.log(222);
      console.log(1, e, data);
      switch (e) {
        case "delete":
          this.$confirm("确认删除？删除后数据不可恢复", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            const keys = [];
            keys.push(data.ID);
            deleteMessages({
              keys,
            }).then((res) => {
              if (res.code === 200) {
                this.$message.success("删除成功");
                this.tableData.splice(index, 1);
              }
            });
          });
          break;
      }
    },
    //全部已读
    getMessageRead() {
      getMessageRead().then((res) => {
        if (res.code === 200) {
          this.$message.success("修改成功");
          this.tableData = this.tableData.map((item) => {
            // 返回一个新对象，展开原对象属性，并覆盖 isActive 为 false
            return { ...item, IsRead: true };
          });
        }
      });
    },
    //全部删除
    clearMessage() {
      this.$confirm("确认清除全部数据？删除后数据不可恢复", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          clearMessage().then((res) => {
            if (res.code === 200) {
              this.$message.success("删除成功");
              this.tableData = [];
            }
          });
        })
        .catch(() => {});
    },
  },
  mounted() {
    //赋值路由
    this.getActive(this.$route.path);
    if (localStorage.getItem("token")) {
      this.token = localStorage.getItem("token");
      if (localStorage.getItem("userInfo")) {
        this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
        this.$store.commit("changeUserInfo", this.userInfo);
      } else {
        getAccount().then((res) => {
          if (res.code === 200) {
            this.userInfo = res.data;
            this.$store.commit("changeUserInfo", this.userInfo);
            localStorage.setItem("userInfo", JSON.stringify(res.data));
          }
        });
      }

      this.getMessageCounts();
      this.getMessages();
    }
  },
};
</script>
<style lang="scss" scoped>
.main {
  background-color: #f7f8fa;
}
.home-herder {
  width: 100%;
  height: 70px;
  position: fixed;
  display: flex;
  align-items: center;
  z-index: 99;
  box-shadow: 0px 3px 20px 1px rgba(0, 0, 0, 0.05);
  .logo {
    width: 145px;
    height: 50px;
    margin-left: 140px;
    cursor: pointer;
  }
  .text-box {
    display: flex;
    align-items: center;
    margin-left: 100px;
    color: #474f66;

    div {
      margin-right: 80px;
      font-size: 16px;
      height: 70px;
      line-height: 70px;
      position: relative;
      cursor: pointer;
      .line {
        position: absolute;
        width: 16px;
        height: 4px;
        border-radius: 2px;
        background-color: #fff;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    .lang-box {
      display: flex;
      align-items: center;
      margin-right: 0;
      // cursor: pointer;
      cursor: no-drop;
      .lang {
        width: 16px;
        height: 16px;
        margin-right: 6px;
        font-size: 16px;
      }
    }

    .btn {
      margin-left: 50px;
      line-height: 30px;
      padding: 0 12px;
      height: 30px;
      border-radius: 18px 18px 18px 18px;
      border: 1px solid #474f66;
      font-size: 14px;
      color: #474f66;
      cursor: pointer;
      display: flex;
      align-items: center;
      .vertical {
        height: 16px;
        width: 1px;
        background-color: #474f66;
        margin: 0 12px;
      }
    }
  }
  .storage-box {
    display: none;
    align-items: center;
    .el-badge {
      height: 24px !important;
      line-height: 24px !important;
      margin-right: 35px !important;
      position: relative;
      .bell {
        width: 30px;
        height: 30px;
      }
      .bell-flex {
        position: absolute;
        bottom: -555px;
        left: -330px;
        width: 352px;
        height: 532px;
        background: #ffffff;
        box-shadow: 0px 3px 10px 1px rgba(0, 0, 0, 0.08);
        border-radius: 4px 4px 4px 4px;
        line-height: 20px;
        margin: 0;

        .bell-title {
          width: 100%;
          display: inline-block;
          line-height: 54px;
          font-size: 15px;
          color: #232323;
          margin: 0;
          text-align: center;
          border-bottom: 1px solid #f2f2f2;
        }
        .bell-operation {
          display: flex;
          justify-content: space-between;
          height: 30px;
          align-items: center;
          color: #8948ff;
          font-size: 14px;
          margin: 0;
          margin-top: 10px;
          box-sizing: border-box;
          padding: 0 15px 0 13px;
        }
        .bell-content {
          overflow: auto;
          width: 100%;
          margin: 0;
          margin-top: 10px;
          height: 420px;
          // box-sizing: border-box;
          padding: 0 15px 0 13px;
          .bell-item {
            height: 50px;
            margin: 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 15px;
            .bell-item-left {
              margin: 0;
              height: 50px;
              display: flex;
              align-items: center;
              .bell2 {
                width: 36px;
                height: 36px;
                margin: 0;
                line-height: normal;
                position: relative;
                img {
                  width: 100%;
                  height: 100%;
                  margin: 0;
                }
                span {
                  position: absolute;
                  width: 7px;
                  height: 7px;
                  border-radius: 3.5px;
                  background: #ff3c3c;
                  top: 0;
                  right: 0;
                }
              }
              .bell-text-box {
                margin: 0;
                height: 50px;
                width: 224px;
                margin-left: 14px;
                line-height: 20px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .bell-text {
                  font-size: 14px;
                  color: #232323;
                  overflow: hidden; /* 确保超出容器的内容被裁剪 */
                  white-space: nowrap; /* 确保文本在一行内显示 */
                  text-overflow: ellipsis; /* 超出部分显示省略号 */
                }
                .bell-time {
                  font-size: 14px;
                  color: #666666;
                }
              }
            }
            .el-dropdown {
              height: 30px;
              margin-right: 15px;
              display: flex;
              align-items: center;
              .treee {
                width: 14px;
                height: 14px;
              }
              div {
                height: 30px;
              }
            }
          }
        }
      }
    }
    .storage {
      width: 36px;
      height: 36px;
      margin-right: 20px;
      cursor: pointer;
    }
  }
}
.home-herder {
  background-color: #fff;
  box-shadow: 0px 3px 20px 1px rgba(0, 0, 0, 0.05);
  .active {
    color: #8948ff;
  }
  .text-box {
    color: #474f66;
    div {
      .line {
        background-color: #8948ff;
      }
    }
  }
}
.user-box {
  margin-left: 70px;
  display: flex;
  align-items: center;
  margin-right: 0 !important;
  .el-badge {
    height: 24px !important;
    line-height: 24px !important;
    margin-right: 35px !important;
    position: relative;
    .bell-flex {
      position: absolute;
      bottom: -555px;
      left: -330px;
      width: 352px;
      height: 532px;
      background: #ffffff;
      box-shadow: 0px 3px 10px 1px rgba(0, 0, 0, 0.08);
      border-radius: 4px 4px 4px 4px;
      line-height: 20px;
      margin: 0;

      .bell-title {
        width: 100%;
        display: inline-block;
        line-height: 54px;
        font-size: 15px;
        color: #232323;
        margin: 0;
        text-align: center;
        border-bottom: 1px solid #f2f2f2;
      }
      .bell-operation {
        display: flex;
        justify-content: space-between;
        height: 30px;
        align-items: center;
        color: #8948ff;
        font-size: 14px;
        margin: 0;
        margin-top: 10px;
        box-sizing: border-box;
        padding: 0 15px 0 13px;
      }
      .bell-content {
        overflow: auto;
        width: 100%;
        margin: 0;
        margin-top: 10px;
        height: 420px;
        box-sizing: border-box;
        padding: 0 15px 0 13px;
        .bell-item {
          height: 50px;
          margin: 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;
          .bell-item-left {
            margin: 0;
            height: 50px;
            display: flex;
            align-items: center;
            .bell2 {
              width: 36px;
              height: 36px;
              margin: 0;
              line-height: normal;
              position: relative;
              img {
                width: 100%;
                height: 100%;
                margin: 0;
              }
              span {
                position: absolute;
                width: 7px;
                height: 7px;
                border-radius: 3.5px;
                background: #ff3c3c;
                top: 0;
                right: 0;
              }
            }
            .bell-text-box {
              margin: 0;
              height: 50px;
              width: 224px;
              margin-left: 14px;
              line-height: 20px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              .bell-text {
                font-size: 14px;
                color: #232323;
                overflow: hidden; /* 确保超出容器的内容被裁剪 */
                white-space: nowrap; /* 确保文本在一行内显示 */
                text-overflow: ellipsis; /* 超出部分显示省略号 */
              }
              .bell-time {
                font-size: 14px;
                color: #666666;
              }
            }
          }
          .el-dropdown {
            height: 30px;
            margin-right: 15px;
            display: flex;
            align-items: center;
            .treee {
              width: 14px;
              height: 14px;
            }
            div {
              height: 30px;
            }
          }
        }
      }
    }
  }
  .bell {
    width: 24px;
    height: 24px;
  }
  .head {
    width: 40px;
    height: 40px;
    border-radius: 20px;
  }
  .name {
    font-size: 16px;
    color: #474f66;
    margin-left: 10px;
    font-weight: 500;
    margin-right: 0 !important;
  }
  .arrow {
    width: 14px;
    height: 14px;
    margin-left: 30px;
  }
}

.content {
  padding-top: 70px;
  min-height: calc(100vh - 470px);
}

//页脚
.footer-box {
  width: 100%;
  height: 400px;
  padding-top: 40px;
  box-sizing: border-box;
  background-color: #fff;
  .content-box {
    width: calc(100% - 280px);
    margin-left: 140px;
    .icon-box {
      width: 145px;
      height: 50px;
      margin-bottom: 31px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .line {
      width: 100%;
      height: 1px;
      background: #e9ecee;
    }
    .info-boxs {
      display: flex;
      margin-top: 39px;
      justify-content: space-between;
      .info-box {
        .herder {
          color: #474f66;
          font-size: 16px;
          display: flex;
          align-items: center;
          span {
            font-size: 14px;
          }
          img {
            width: 20px;
            height: 20px;
            margin-right: 10px;
          }
        }
        .tips {
          width: 200px;
          font-size: 14px;
          color: #474f66;
          margin-top: 34px;
          line-height: 30px;
        }
        .item-box {
          display: flex;
          flex-direction: column;
          margin-top: 34px;
          .item {
            margin-bottom: 24px;
            color: #474f66;
            cursor: pointer;
          }
          .item:last-child {
            margin-bottom: 0;
          }
        }
        .code-box {
          img {
            width: 82px;
            height: 82px;
            margin-top: 35px;
          }
          div {
            width: 82px;
            text-align: center;
            font-size: 14px;
            color: #474f66;
          }
        }
      }
    }
  }
  .filing {
    text-align: center;
    color: #474f66;
    margin-top: 40px;
    font-size: 14px;
  }
}

//页脚2
.footer-box2 {
  width: 100%;
  height: 400px;
  padding-top: 40px;
  box-sizing: border-box;
  background-color: #fff;
  display: none;
  .content-box {
    width: calc(100% - 28px);
    margin-left: 14px;
    .icon-box {
      width: 101px;
      height: 34px;
      margin-bottom: 30px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .line {
      width: 100%;
      height: 1px;
      background: #e9ecee;
    }
    .info-boxs {
      display: flex;
      margin-top: 49px;
      flex-direction: column;
      .info-box {
        margin-bottom: 27px;
        .item-box {
          display: flex;
          justify-content: space-between;
          .item {
            color: #474f66;
          }
          .item:last-child {
            margin-bottom: 0;
          }
          .herder {
            color: #474f66;
            font-size: 16px;
            display: flex;
            align-items: center;
            span {
              font-size: 14px;
            }
            img {
              width: 20px;
              height: 20px;
              margin-right: 10px;
            }
          }
        }
      }
    }
  }
  .filing {
    text-align: center;
    font-size: 12px;
    color: #474f66;
    line-height: 20px;
    margin-top: 30px;
  }
}

.empty-box {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-right: 0 !important;
  margin-top: 130px;
  .el-empty {
    margin-right: 0 !important;
  }
}
</style>


<style lang="scss" scoped>
/* 媒体查询 */
@media only screen and (max-width: 1380px) {
  .home-herder {
    .logo {
      margin-left: 70px;
    }
    .text-box {
      margin-left: 50px;
      div {
        margin-right: 60px;
      }
    }
  }

  //页脚
  .footer-box {
    .content-box {
      width: calc(100% - 140px);
      margin-left: 70px;
      margin-top: 60px;
    }
  }
}
@media only screen and (max-width: 1200px) {
  //页脚
  .footer-box {
    .content-box {
      width: calc(100% - 60px);
      margin-left: 30px;
      margin-top: 60px;
    }
  }
}
@media only screen and (max-width: 1140px) {
  .home-herder {
    .logo {
      margin-left: 70px;
    }
    .text-box {
      margin-left: 50px;
      div {
        margin-right: 50px;
      }
      .user-box {
        margin-left: 40px;
      }
    }
  }
}
@media only screen and (max-width: 1100px) {
  .home-herder {
    .logo {
      margin-left: 70px;
    }
    .text-box {
      margin-left: 50px;
      div {
        margin-right: 40px;
      }
      .user-box {
        margin-left: 40px;
      }
    }
  }
}
@media only screen and (max-width: 1000px) {
  .home-herder {
    display: flex;
    justify-content: space-between;
    .logo {
      margin-left: 20px;
    }
    .text-box {
      display: none;
    }

    .storage-box {
      display: flex;
    }
  }
  //页脚
  .footer-box {
    display: none;
  }
  .footer-box2 {
    display: block;
  }
}
@media only screen and (max-width: 500px) {
  .main {
    .home-herder {
      .storage-box {
        .item {
          .bell-flex {
            width: 90vw;
            position: fixed;
            top: 70px;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
    }
  }
}
</style>